// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2dqRl","inner":"style_inner__3eFJJ","bottom":"style_bottom__2L4M9","copyright":"style_copyright__1WYSK"};